import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';
import { NebulaMediaWatcherService } from '@scientifica-cms-fe/services/media-watcher';
import { NebulaNavigationService, FuseVerticalNavigationComponent } from '@scientifica-cms-fe/components/navigation';
import { Navigation } from 'app/core/navigation/navigation.types';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { AuthService } from "../../../../core/auth/auth.service";
import { UserService } from "../../../../core/user/user.service";

@Component({
    selector: 'modern-layout',
    templateUrl: './modern.component.html',
    styleUrls: ['./modern.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ModernLayoutComponent implements OnInit, OnDestroy {
    isScreenSmall: boolean;
    navigation: Navigation;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    // showLoader  : boolean;

    /**
     * Constructor
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _navigationService: NavigationService,
        private _nebulaMediaWatcherService: NebulaMediaWatcherService,
        private _nebulaNavigationService: NebulaNavigationService,
        private authService: AuthService,
        private userService: UserService
        // private loaderService : LoaderService
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number {
        return new Date().getFullYear();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {


        // Subscribe to navigation data
        // this._navigationService.navigation$
        this.userService.user$
            .pipe(takeUntil(this._unsubscribeAll),

                switchMap((user) => {
                    return this._navigationService.navigation$;
                }))
            .subscribe((navigation: Navigation) => {
                const filteredNavigation = {
                    ...navigation,
                    horizontal: navigation.horizontal.filter(h => this.authService.hasRole(h.roles))
                }
                console.log(filteredNavigation);

                this.navigation = filteredNavigation;
            });

        // Subscribe to media changes
        this._nebulaMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((res) => {

                // Check if the screen is small
                this.isScreenSmall = res.breakpoints ?
                    res.breakpoints['(max-width: 550px)'] : false;
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void {
        // Get the navigation
        const navigation = this._nebulaNavigationService.getComponent<FuseVerticalNavigationComponent>(name);

        if (navigation) {
            // Toggle the opened status
            navigation.toggle();
        }
    }
}
